var _defs, _path, _path2, _path3, _path4, _g, _g2, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 701.4 200.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: url(#radial-gradient);\n      }\n\n      .st2 {\n        fill: url(#radial-gradient1);\n      }\n\n      .st3 {\n        fill: url(#radial-gradient6);\n      }\n\n      .st4 {\n        fill: url(#radial-gradient3);\n      }\n\n      .st5 {\n        fill: url(#radial-gradient2);\n      }\n\n      .st6 {\n        fill: url(#radial-gradient5);\n      }\n\n      .st7 {\n        fill: url(#radial-gradient4);\n      }\n\n      .st8 {\n        fill: url(#radial-gradient7);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 309,
    cy: -59.4,
    fx: 309,
    fy: -59.4,
    r: 196.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6c990"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f04f23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#201126"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: 433.8,
    cy: -46,
    fx: 433.8,
    fy: -46,
    r: 182.2,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient2",
    cx: 551.4,
    cy: -58.5,
    fx: 551.4,
    fy: -58.5,
    r: 197,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient3",
    cx: 631.6,
    cy: -58.7,
    fx: 631.6,
    fy: -58.7,
    r: 202.7,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient4",
    cx: 146.8,
    cy: -52.2,
    fx: 146.8,
    fy: -52.2,
    r: 184.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient5",
    cx: 48.8,
    cy: -66.1,
    fx: 48.8,
    fy: -66.1,
    r: 216.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient6",
    cx: 48.8,
    cy: -66.1,
    fx: 48.8,
    fy: -66.1,
    r: 216.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient7",
    cx: 545.5,
    cy: -67.2,
    fx: 545.5,
    fy: -67.2,
    r: 146.1,
    xlinkHref: "#radial-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.7,54.6h-4.7c-6.7,0-13,1.6-19.1,4.7-6,3.2-11.2,7.3-15.5,12.6-2.2,2.6-4.1,5.4-5.7,8.4v-23h-26v140.3h26v-82.2c.8-3.3,2.1-6.7,3.8-10.4,2.3-5.1,5.5-9.8,9.3-13.9,3.9-4.1,8.8-7.3,14.7-9.5,5.9-2.2,12.9-2.5,20.8-1.1v-25.4c-1.1-.4-2.3-.5-3.7-.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M440.3,200.4c-17.3.2-35.8-8.7-44.9-23.3v20.6h-26V0h26v77.6c24.2-36.4,85.2-27,102.4,12.2,23.3,43.9-1.7,112.3-57.5,110.6ZM436.5,177.4c37.8,1.1,51.7-47.5,37.3-76.3-18.8-39.6-76.4-26-78.4,17-2.7,28.8,8.1,58.5,41.1,59.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M561.7,180.4v17.3h-26V57.3h26v123Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M648.2,200.4c-28.1.7-55.3-14.6-59.5-42.5l24.1-8.4h1.1c1.8,26.5,40.5,38.9,56.9,18.8,8.3-13.2-.4-27.3-15.5-29.6-24.2-5.8-63.8-9.7-61.9-43.3,1.6-53.6,95.5-54.2,104.6-4.1l-24.3,7.3h-1.1c-1.3-26.5-49-32.6-52.2-5.1,0,10.2,8.1,14.1,17.6,16.5,12.1,3.1,32.7,7.3,43.5,12.8,20.7,8.5,25.6,38.2,13,56.4-10.2,14.5-27.6,21.2-46.2,21.1Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.9,99.9l28.9,3.3c2.3.3,4.1,2.2,4.1,4.6,0,2.4-1.7,4.3-4.1,4.6l-28.9,3.6c-7.5.9-13.5,6.9-14.3,14.5l-.9,8.1c3,6.6,6.9,12.5,11.5,17.7,6,6.8,13.2,12,21.4,15.8,8.2,3.8,17.3,5.7,27.2,5.7s15.3-1.2,22.2-3.7c6.8-2.4,13.1-5.9,18.7-10.3,5.6-4.4,10.4-9.8,14.3-16.1,4-6.3,7-13.3,9.2-21,2.2-7.7,3.2-15.9,3.2-24.7s-1.7-20.8-5-30c-3.3-9.2-8-17.2-14.1-23.9-6-6.8-13.2-12-21.5-15.8-8.3-3.8-17.3-5.7-27-5.7s-15.1,1.2-22,3.7c-6.9,2.4-13.2,5.9-18.8,10.4-5.6,4.5-10.4,9.9-14.3,16.1-2.4,3.7-4.4,7.7-6.2,12l2.1,16.8c.9,7.5,6.9,13.5,14.5,14.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M233.8,59.9C209.3-9.4,109.2-20.7,67.2,37.7c-.9,1.3-1.4,2.9-1.2,4.5h0c.6,5.2,7,7.3,10.6,3.7,43.5-43.6,115.4-9.2,113.6,56.3.4,30.7-15.5,62-45.4,72.1-23.5,8.5-51.3,2.2-68.6-15.4-2.8-2.9-7.7-1.1-8.2,2.9h0c-.1,1.2.2,2.4.9,3.4,25.4,33.6,75.9,44.1,114.1,28,50.7-19.7,69.9-84.9,50.7-133.2Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M36.1,88.9c-1.9,1.9-4,3.4-6.3,4.3-2.3.9-4.7,1.4-7.1,1.3-2.4,0-4.8-.6-7.2-1.7-2.4-1-4.6-2.6-6.6-4.6s-3.6-4.2-4.7-6.6c-1.1-2.4-1.6-4.7-1.7-7.2,0-2.4.3-4.8,1.2-7.1.9-2.3,2.3-4.4,4.2-6.4,1.9-1.9,4-3.4,6.3-4.3,2.3-.9,4.6-1.4,7.1-1.3,2.4,0,4.9.6,7.2,1.7,2.4,1,4.6,2.6,6.6,4.6s3.6,4.2,4.7,6.6c1.1,2.4,1.6,4.8,1.7,7.2,0,2.4-.3,4.8-1.2,7.1-.9,2.3-2.3,4.4-4.2,6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M106.8,103.3l-28.9-3.3c-7.6-.9-13.5-6.8-14.5-14.3l-3.6-28.9c-.3-2.3-2.3-4.1-4.6-4.1h0c-2.4,0-4.3,1.8-4.6,4.1l-3.3,28.9c-.9,7.6-6.8,13.5-14.3,14.5l-28.9,3.6C1.7,104,0,106,0,108.3h0c0,2.4,1.8,4.3,4.1,4.6l28.9,3.3c7.6.9,13.5,6.8,14.5,14.3l3.6,28.9c.3,2.3,2.3,4.1,4.6,4.1h0c2.4,0,4.3-1.8,4.6-4.1l3.3-28.9c.9-7.6,6.8-13.5,14.3-14.5l28.9-3.6c2.3-.3,4.1-2.3,4.1-4.6h0c0-2.4-1.8-4.3-4.1-4.6Z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M548.7,35.1c-4.9,0-8.9-1.7-12.2-5-3.3-3.3-4.9-7.4-4.9-12.1s1.6-8.7,4.9-12.1c3.3-3.3,7.3-5,12.2-5s9,1.7,12.3,5c3.3,3.3,5,7.4,5,12.1s-1.7,8.7-5,12.1c-3.3,3.3-7.5,5-12.3,5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b3f34a02c86c663a08140b9609ddef3b.svg";
export { ForwardRef as ReactComponent };